import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, FormHelperText, Tooltip, IconButton, InputAdornment } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const SemesterSelector = ({
  value = '',
  onChange,
  error = false,
  helperText = '',
  required = false,
  labelPrefix = ''
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);

  const [year, period] = value && value !== 'NINGUNO' ? value.split('-') : ['', ''];

  const handleYearChange = (event) => {
    const newYear = event.target.value;
    if (!newYear && !period) {
      onChange('');
    } else if (newYear && period) {
      onChange(`${newYear}-${period}`);
    } else {
      onChange(newYear ? `${newYear}-${period || ''}` : `${year || ''}-${period || ''}`);
    }
  };

  const handlePeriodChange = (event) => {
    const newPeriod = event.target.value;
    if (!year && !newPeriod) {
      onChange('');
    } else if (year && newPeriod) {
      onChange(`${year}-${newPeriod}`);
    } else {
      onChange(newPeriod ? `${year || ''}-${newPeriod}` : `${year || ''}-${period || ''}`);
    }
  };

  const handleClearSelection = () => {
    onChange('');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
        <FormControl fullWidth error={error}>
          <InputLabel id={`${labelPrefix}year-label`}>
            Año{required ? ' *' : ''}
          </InputLabel>
          <Select
            labelId={`${labelPrefix}year-label`}
            value={year}
            label={`Año${required ? ' *' : ''}`}
            onChange={handleYearChange}
            sx={{ minHeight: 44 }}
          >
            <MenuItem value="">
              <em>Ninguno</em>
            </MenuItem>
            {years.map(yearOption => (
              <MenuItem key={yearOption} value={yearOption}>
                {yearOption}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth error={error}>
          <InputLabel id={`${labelPrefix}period-label`}>
            Período{required ? ' *' : ''}
          </InputLabel>
          <Select
            labelId={`${labelPrefix}period-label`}
            value={period}
            label={`Período${required ? ' *' : ''}`}
            onChange={handlePeriodChange}
            sx={{ minHeight: 44 }}
          >
            <MenuItem value="">
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="1">1</MenuItem>
            <MenuItem value="2">2</MenuItem>
          </Select>
        </FormControl>
        <Tooltip
          title="Campos destinados al período académico que se compone del año y el período (1 o 2)"
          arrow
          placement="right"
        >
          <IconButton size="small" sx={{ mt: 1 }}>
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      {(year || period) && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <a
            onClick={handleClearSelection}
            style={{
              fontSize: '0.875rem',
              cursor: 'pointer',
              textDecoration: 'underline',
              color: '#1976d2'
            }}
          >
            Limpiar
          </a>
        </Box>
      )}
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </Box>
  );
};

export default SemesterSelector;